/* BlackPeak — storefront interactions (vanilla, no deps) */
(function () {
  "use strict";
  var BP = window.BlackPeak || {};
  var routes = BP.routes || {};
  var MONEY = BP.moneyFormat || "₹{{amount}}";
  var THRESHOLD = BP.freeShipThreshold || 0; // in paise/cents

  /* ---------- money ---------- */
  function formatMoney(cents) {
    cents = Number(cents) || 0;
    var value = (cents / 100).toFixed((cents % 100 === 0) ? 0 : 2);
    var parts = value.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var amount = parts.join(".");
    return MONEY.replace(/\{\{\s*amount[^}]*\}\}/g, amount);
  }

  /* ---------- helpers ---------- */
  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }

  /* ---------- mobile nav ---------- */
  on($("[data-nav-toggle]"), "click", function () {
    var h = $(".header"); if (h) h.classList.toggle("nav-open");
  });

  /* ---------- scroll reveal ---------- */
  var reveals = $all(".reveal");
  if ("IntersectionObserver" in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    reveals.forEach(function (el) { io.observe(el); });
  } else { reveals.forEach(function (el) { el.classList.add("in"); }); }

  /* ---------- FAQ single-open (native details) ---------- */
  $all("details.faq__item").forEach(function (d) {
    on(d, "toggle", function () {
      if (d.open) $all("details.faq__item").forEach(function (o) { if (o !== d) o.open = false; });
    });
  });

  /* ========================================================================
     CART
     ======================================================================== */
  var drawer = $("#CartDrawer");
  var overlay = $("#DrawerOverlay");

  function openDrawer() { if (drawer) { drawer.classList.add("open"); overlay && overlay.classList.add("open"); document.body.style.overflow = "hidden"; } }
  function closeDrawer() { if (drawer) { drawer.classList.remove("open"); overlay && overlay.classList.remove("open"); document.body.style.overflow = ""; } }

  $all("[data-cart-toggle]").forEach(function (b) { on(b, "click", function (e) { e.preventDefault(); openDrawer(); refreshCart(); }); });
  $all("[data-cart-close]").forEach(function (b) { on(b, "click", closeDrawer); });
  on(overlay, "click", closeDrawer);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });

  function setCartCount(n) { $all("[data-cart-count]").forEach(function (el) { el.textContent = n; el.style.display = n > 0 ? "" : "none"; }); }

  function renderShipBar(total) {
    var fill = $("[data-ship-fill]"), txt = $("[data-ship-text]");
    if (!fill || !txt) return;
    if (!THRESHOLD) { txt.textContent = ""; fill.style.width = "0%"; return; }
    if (total >= THRESHOLD) { txt.textContent = (BP.strings && BP.strings.freeUnlocked) || "Free shipping unlocked!"; fill.style.width = "100%"; }
    else {
      var remain = THRESHOLD - total;
      var tpl = (BP.strings && BP.strings.almostFree) || "Add {{ amount }} for free shipping";
      txt.textContent = tpl.replace(/\{\{\s*amount[^}]*\}\}/g, formatMoney(remain));
      fill.style.width = Math.min(100, (total / THRESHOLD) * 100) + "%";
    }
  }

  function renderCart(cart) {
    setCartCount(cart.item_count);
    renderShipBar(cart.total_price);
    var wrap = $("[data-drawer-items]");
    var foot = $("[data-drawer-foot]");
    if (!wrap) return;
    if (!cart.item_count) {
      wrap.innerHTML = '<div class="drawer__empty">' + ((BP.strings && BP.strings.empty) || "Your box is empty. Kashmir's waiting.") + "</div>";
      if (foot) foot.style.display = "none";
      return;
    }
    if (foot) foot.style.display = "";
    wrap.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[^.]+)(\?.*)?$/, "_120x$1$2") : "";
      return '' +
        '<div class="line">' +
          '<img src="' + img + '" alt="' + (it.product_title || "") + '" loading="lazy">' +
          '<div>' +
            '<div class="line__name">' + it.product_title + (it.variant_title && it.variant_title !== "Default Title" ? " · " + it.variant_title : "") + '</div>' +
            '<div class="line__price">' + it.quantity + " × " + formatMoney(it.final_price) + '</div>' +
            '<button class="line__remove" data-line-remove data-key="' + it.key + '">Remove</button>' +
          '</div>' +
          '<div class="line__price">' + formatMoney(it.final_line_price) + '</div>' +
        '</div>';
    }).join("");
    var sub = $("[data-subtotal]"); if (sub) sub.textContent = formatMoney(cart.total_price);
    $all("[data-line-remove]", wrap).forEach(function (b) {
      on(b, "click", function () { changeLine(b.getAttribute("data-key"), 0); });
    });
  }

  function refreshCart() {
    fetch(routes.cart_json || "/cart.js", { headers: { "Content-Type": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(renderCart).catch(function () {});
  }

  function changeLine(key, qty) {
    fetch(routes.cart_change || "/cart/change.js", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  function addItems(items, opts) {
    opts = opts || {};
    return fetch(routes.cart_add || "/cart/add.js", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    }).then(function () {
      refreshCart();
      if (!opts.silent) openDrawer();
    });
  }

  /* ---------- product forms (AJAX) ---------- */
  $all('form[data-product-form]').forEach(function (form) {
    on(form, "submit", function (e) {
      e.preventDefault();
      var id = form.querySelector('[name="id"]');
      var qty = form.querySelector('[name="quantity"]');
      if (!id || !id.value) return;
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.dataset.label = btn.textContent; btn.textContent = "Adding…"; btn.disabled = true; }
      addItems([{ id: Number(id.value), quantity: Number(qty && qty.value) || 1 }]).finally(function () {
        if (btn) { btn.textContent = btn.dataset.label || "Add to box"; btn.disabled = false; }
      });
    });
  });

  /* ---------- quick add buttons ---------- */
  $all("[data-quick-add]").forEach(function (b) {
    on(b, "click", function (e) {
      e.preventDefault();
      var vid = b.getAttribute("data-variant-id"); if (!vid) return;
      var lbl = b.textContent; b.textContent = "Adding…"; b.disabled = true;
      addItems([{ id: Number(vid), quantity: 1 }]).finally(function () { b.textContent = lbl; b.disabled = false; });
    });
  });

  /* ---------- pack/variant selector on PDP ---------- */
  $all("[data-pack-opt]").forEach(function (opt) {
    on(opt, "click", function () {
      var group = opt.closest("[data-packs]"); if (!group) return;
      $all("[data-pack-opt]", group).forEach(function (o) { o.classList.remove("is-selected"); });
      opt.classList.add("is-selected");
      var form = $("form[data-product-form]");
      var vid = opt.getAttribute("data-variant-id");
      var price = opt.getAttribute("data-price");
      var link = opt.getAttribute("data-link");
      if (vid && form) { var idf = form.querySelector('[name="id"]'); if (idf) idf.value = vid; }
      if (link && !vid) { /* pack routes elsewhere (builder/giftbox) */ }
      var sp = $("[data-sticky-price]"); if (sp && price) sp.textContent = price;
    });
  });

  /* ---------- sticky mobile ATC ---------- */
  var stickyAtc = $("[data-sticky-atc]");
  var atcAnchor = $("[data-atc-anchor]");
  if (stickyAtc && atcAnchor && "IntersectionObserver" in window) {
    var sio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { stickyAtc.classList.toggle("show", !en.isIntersecting); });
    }, { rootMargin: "-80px 0px 0px 0px" });
    sio.observe(atcAnchor);
  }
  on($("[data-sticky-add]"), "click", function () {
    var form = $("form[data-product-form]"); if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event("submit", { cancelable: true }));
  });

  /* ========================================================================
     BUILD YOUR OWN (mix-and-match)
     ======================================================================== */
  var byo = $("[data-byo]");
  if (byo) {
    var MAX = Number(byo.getAttribute("data-max")) || 12;
    var perCan = Number(byo.getAttribute("data-per-can")) || 0; // paise
    var rows = $all("[data-byo-row]", byo);
    var countEl = $("[data-byo-count]", byo);
    var barEl = $("[data-byo-bar]", byo);
    var hintEl = $("[data-byo-hint]", byo);
    var priceEl = $("[data-byo-price]", byo);
    var addBtn = $("[data-byo-add]", byo);

    function rowQty(row) { return Number(row.querySelector("output").value) || 0; }
    function total() { return rows.reduce(function (s, r) { return s + rowQty(r); }, 0); }

    function render() {
      var t = total();
      if (countEl) countEl.textContent = t + " / " + MAX;
      if (barEl) barEl.style.width = Math.min(100, (t / MAX) * 100) + "%";
      if (priceEl) priceEl.textContent = formatMoney(perCan * t);
      if (hintEl) {
        if (t === 0) hintEl.textContent = "Pick " + MAX + " cans — mix all three.";
        else if (t < MAX) hintEl.textContent = (MAX - t) + " to go — keep stacking.";
        else hintEl.textContent = "Box full. " + MAX + " of " + MAX + " — nice mix.";
      }
      if (addBtn) addBtn.disabled = (t !== MAX);
      rows.forEach(function (r) {
        var up = r.querySelector('[data-step="up"]');
        if (up) up.disabled = (t >= MAX);
      });
    }

    rows.forEach(function (row) {
      var out = row.querySelector("output");
      on(row.querySelector('[data-step="up"]'), "click", function () {
        if (total() >= MAX) return; out.value = (Number(out.value) || 0) + 1; render();
      });
      on(row.querySelector('[data-step="down"]'), "click", function () {
        out.value = Math.max(0, (Number(out.value) || 0) - 1); render();
      });
    });

    on($('[data-preset="even"]', byo), "click", function () {
      var base = Math.floor(MAX / rows.length), rem = MAX % rows.length;
      rows.forEach(function (r, i) { r.querySelector("output").value = base + (i < rem ? 1 : 0); });
      render();
    });
    on($('[data-preset="random"]', byo), "click", function () {
      rows.forEach(function (r) { r.querySelector("output").value = 0; });
      for (var i = 0; i < MAX; i++) { rows[Math.floor(Math.random() * rows.length)].querySelector("output").value++; }
      render();
    });

    on(addBtn, "click", function () {
      var items = rows.map(function (r) {
        return { id: Number(r.getAttribute("data-variant-id")), quantity: rowQty(r) };
      }).filter(function (i) { return i.id && i.quantity > 0; });
      if (!items.length) return;
      addBtn.disabled = true; var lbl = addBtn.textContent; addBtn.textContent = "Adding…";
      addItems(items).finally(function () { addBtn.textContent = lbl; render(); });
    });

    render();
  }

  /* ---------- newsletter reveal code on success handled by Shopify form ---------- */

  /* init cart count on load */
  refreshCart();
})();
